export var RMAItemType;
(function (RMAItemType) {
    RMAItemType[RMAItemType["RETURN"] = 1] = "RETURN";
    RMAItemType[RMAItemType["CREDIT"] = 2] = "CREDIT";
})(RMAItemType || (RMAItemType = {}));
//# sourceMappingURL=rma-item-type.js.map